import i18next from 'i18next';

import Logger from 'wanderu-logger';

import newLineInjector from '../newLineInjector.js';
import reactElementInjector from '../reactElementInjector.js';

const logger = Logger.getLogger('i18next');

const I18NEXT_NAMESPACE = 'translation';

const DEFAULT_I18NEXT_OPTS = {
    defaultNS: 'translation',
    fallbackNS: 'translation',
    fallbackLng: 'en-us',
    interpolation: {
        prefix: '__',
        suffix: '__',
        escapeValue: false,
        unescapePrefix: '~', // https://github.com/i18next/i18next/issues/1001
    },
    lowerCaseLng: true,
    postProcess: ['reactElementInjector', 'newLineInjector'],
    useCookie: false,
    saveMissing: true,
    missingKeyHandler: (_lngs, ns, key, fallbackValue) => {
        // This is very noisy, we should find a way of doing this without emitting duplicate warns.

        // logger.warn('Missing translation', {
        //     namespace: ns,
        //     key,
        //     fallbackValue,
        // });
    },
};

class I18next {
    constructor() {
        this._instance = i18next.createInstance();
    }

    async init(opts) {
        const {
            locale,
            translationDictionary,
        } = opts;

        await new Promise((resolve, reject) => {
            this._instance
                .use(reactElementInjector)
                .use(newLineInjector)
                .init({
                    ...DEFAULT_I18NEXT_OPTS,
                    lng: locale,
                }, resolve);
        });

        if (translationDictionary) {
            this.loadTranslationStrings(locale, translationDictionary);
        }
    }

    setLocale(locale) {
        this._instance.changeLanguage(locale);
    }

    addLanguageChangeListener(callback) {
        this._instance.on('languageChanged', callback);
        this._instance.store.on('added', callback); // also need to know when dictionaries are added
    }

    removeLanguageChangeListener(callback) {
        this._instance.off('languageChanged', callback);
        this._instance.store.off('added', callback);
    }

    hasResourceBundle(locale, ns = I18NEXT_NAMESPACE) {
        return this._instance.hasResourceBundle(locale, ns);
    }

    loadTranslationStrings(
        locale,
        dictionary,
        ns = I18NEXT_NAMESPACE,
        deep = true,
        overwrite = true,
    ) {
        this._instance.addResourceBundle(locale, ns, dictionary, deep, overwrite);
    }

    translate(key, ...args) {
        return this._instance.t(key, ...args);
    }

    /**
     * returns a translation which assumes the given namespace. Function can be broken out of by
       including an explicit namespace in the i18n key string
     *
     * @param {String} namespace
     * @return {Function} a t-pinned by default to the provided namespace
     */
    getT(namespace) {
        return this._instance.getFixedT(null, namespace || null);
    }

    makeTfn(ns) {
        const tfn = this.getT(ns);

        tfn.plural = function(key, count, opts) {
            return tfn(key, {
                ...opts,
                count,
            });
        };

        return tfn;
    }
}

const i18nextSingleton = new I18next();
export {
    i18nextSingleton as i18next,
};
export default I18next;
